// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Go3JyWApfbVUoySiPUEJ {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;
  height: 100vh;
  width: 100vw;
  background-image: url("https://i.imgur.com/Qod4yMp.jpeg");
  background-size: 100%;
}
.Go3JyWApfbVUoySiPUEJ .dX49Q0I4q97sDtwKTDnS {
  width: 50vmin;
  border-radius: 10px;
  border: 2px solid white;
}
.Go3JyWApfbVUoySiPUEJ .vcrVA5h0hm84MnUGuJvE {
  color: white;
  text-shadow: 5px 5px 5px black;
  font-size: 5vmin;
}
.Go3JyWApfbVUoySiPUEJ .IKaanuvKG6cR6NsgcLQK {
  color: white;
  text-shadow: 5px 5px 5px black;
  font-size: 3vmin;
}
.Go3JyWApfbVUoySiPUEJ .R8AmM0_DjXdgTqHDK1mH {
  font-size: 4vmin;
  color: white;
  background-color: red;
  border: none;
  box-shadow: 2px 2px 2px white;
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Game/Game.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,yDAAA;EACA,qBAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAER;AAAI;EACI,YAAA;EACA,8BAAA;EACA,gBAAA;AAER;AAAI;EACI,YAAA;EACA,8BAAA;EACA,gBAAA;AAER;AAAI;EACI,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;AAER","sourcesContent":[".game {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 3rem;\n    height: 100vh;\n    width: 100vw;\n    background-image: url('https://i.imgur.com/Qod4yMp.jpeg');\n    background-size: 100%;\n    .image{\n        width: 50vmin;\n        border-radius: 10px;\n        border: 2px solid white;\n    }\n    .name {\n        color: white;\n        text-shadow: 5px 5px 5px black;\n        font-size: 5vmin;\n    }\n    .price {\n        color: white;\n        text-shadow: 5px 5px 5px black;\n        font-size: 3vmin;\n    }\n    .button {\n        font-size: 4vmin;\n        color: white;\n        background-color: red;\n        border: none;\n        box-shadow: 2px 2px 2px white;\n        margin-bottom: 2rem;\n    }\n}\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"game": `Go3JyWApfbVUoySiPUEJ`,
	"image": `dX49Q0I4q97sDtwKTDnS`,
	"name": `vcrVA5h0hm84MnUGuJvE`,
	"price": `IKaanuvKG6cR6NsgcLQK`,
	"button": `R8AmM0_DjXdgTqHDK1mH`
};
export default ___CSS_LOADER_EXPORT___;
